import React from "react";
import "./Domain.scss";
import Data from "../../../WebBatch/Json";
import { useLocation } from "react-router-dom";

const Domain = () => {
  const location = useLocation();

  const select = location.pathname.includes("/it-internship")
    ? "Internship"
    : location.pathname.includes("/it-training")
    ? "Learning"
    : "choose";

  const isInternship = select === "Internship";

  return (
    <section className="domain-section">
      <div className="domain-grid">
        {Data.map((item) => (
          <div
            key={item.id}
            className={`domain-card ${
              isInternship ? "internship-card" : ""
            }`}
          >
            <div className="domain-content">

              {isInternship && (
                <div className="internship-label">
                  IT INTERNSHIP
                </div>
              )}

              <h3 className="domain-title">
                {isInternship ? item.batch : item.cbatch}
              </h3>

              {isInternship && (
                <>
                  <div className="price-section">
                    <span className="price">₹2,500</span>
                    <span className="per-month"> including tax</span>
                  </div>

                  <div className="internship-details">
                    <div>✓ Practical Training</div>
                    <div>✓ Industry Projects</div>
                    <div>✓ Internship Certificate</div>
                  </div>
                </>
              )}

              <button
                className="domain-btn"
                onClick={() =>
                  window.open(
                    `/course-batch/${
                      isInternship ? item.param : item.cparam
                    }`
                  )
                }
              >
                Know More
              </button>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Domain;